<template>
  <TabelasDetalheTransferencia :tipoTransferencia="'transferencia_interna'" />
</template>

<script>
import TabelasDetalheTransferencia from "../components/TabelaDetalheTransferencia.vue";
export default {
  components: { TabelasDetalheTransferencia },
  setup() {
    return {};
  },
};
</script>
